import { render, staticRenderFns } from "./lactateTextDetail.vue?vue&type=template&id=2cb94baf&scoped=true"
import script from "./lactateTextDetail.vue?vue&type=script&lang=js"
export * from "./lactateTextDetail.vue?vue&type=script&lang=js"
import style0 from "./lactateTextDetail.vue?vue&type=style&index=0&id=2cb94baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb94baf",
  null
  
)

export default component.exports